import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
  editData: {},
};

export const doctorHolidayFormSlice = createSlice({
  name: "doctorHolidayFormReducer",
  initialState,
  reducers: {
    setDoctorHolidayData: (state, action) => {
      state.editData = action.payload;
    },

    setAreaData: (state, action) => {
      state.filters.area = action.payload;
    },

    setConsultData: (state, action) => {
      state.filters.consult = action.payload;
    },

    resetState: (state, action) => {
      state.editData = {};
    },
  },
});

export const { resetState, setDoctorHolidayData, setAreaData, setConsultData } =
  doctorHolidayFormSlice.actions;

export default doctorHolidayFormSlice.reducer;
